import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useSubscription } from 'shared/context/subscriptionContext';
import BrandLoadingSpinner from 'shared/components/ui/BrandLoadingSpinner';

/**
 * Route-level protection component that checks subscription access before allowing navigation
 * Redirects to team Chat when access is denied — not bare /dashboard.
 */
const SubscriptionProtectedRoute = ({ children, requiredPage, redirectTo }) => {
  const { team } = useParams();
  const { canAccessPage, loading } = useSubscription();

  const defaultRedirect =
    team && typeof team === 'string'
      ? `/${encodeURIComponent(team)}/chat`
      : '/dashboard';

  // Show loading spinner while subscription status is being determined
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <BrandLoadingSpinner message="Verifying access..." />
      </div>
    );
  }

  // Check if user has access to the required page
  const hasAccess = canAccessPage(requiredPage);

  // If user doesn't have access, redirect to allowed page
  if (!hasAccess) {
    return <Navigate to={redirectTo ?? defaultRedirect} replace />;
  }

  // User has access, render the children
  return <>{children}</>;
};

export default SubscriptionProtectedRoute;
